import { type HttpClient } from '@/application/interfaces/http-client';

import { createCreditCardSession } from './create-credit-card-session';
import { verifyCreditCardToken } from './verify-credit-card-token';

export const CreditCard = (httpClient: HttpClient.Instance) => ({
  createCreditCardSession: createCreditCardSession(httpClient),
  verifyCreditCardToken: verifyCreditCardToken(httpClient),
});
